import axios from 'axios';

export default {
  new(projectId, data) {
    // An amount of money is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
    data.amount *= 100;
    return axios.post(`/projects/${projectId}/contributions`, data);
  },
  show(transactionId, succ) {
    axios.get('/contributions', { params: { mangopay_transaction_id: transactionId } }).then((response) => {
      succ(response.data);
    });
  },
  userContributions(userId, succ) {
    axios.get(`/users/${userId}/contributions`).then((response) => {
      // reward price is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
      response.data.forEach((contribution) => {
        contribution.amount /= 100;
      });
      succ(response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/contributions.js